<template>
  <!-- 购物车优惠明细 -->
  <van-action-sheet v-model:show="isShow" title="优惠明细" safe-area-inset-bottom>
    <div class="box" v-if="isShow">
      <div class="rowWrap fvlr" v-if="!fromOrder">
        <span>商品总额 </span><span> {{ `¥ ${datas.totalPrice ? datas.totalPrice : 0}` }}</span>
      </div>
      <div class="rowWrap">
        <span>选择优惠券</span>
        <p class="explain">您选择的轮胎产品适用多种优惠券，已为您自动选择最优惠组合</p>
        <div class="couponBox">
          <van-checkbox-group v-model="result" ref="checkboxGroup">
            <van-cell-group>
              <van-swipe-cell>
                <template v-for="(item, index) in couponData" :key="item.id">
                  <couponCard class="couponCard" :datas="{ ...item, selectCouponValue }" :index="index" :checkboxRefs="checkboxRefs"> </couponCard>
                </template>
              </van-swipe-cell>
            </van-cell-group>
          </van-checkbox-group>
          <div class="notSelect" @click.stop>
            <van-row class="fvlr">
              <van-col span="22"> 暂不使用优惠券 </van-col>
              <van-col span="2">
                <van-checkbox v-model="notUseCoupon" shape="square" icon-size="14px"></van-checkbox>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
      <div v-if="!fromOrder" class="rowWrap fvlr total">
        <span>共优惠</span><span class="totalNum">{{ `- ¥ ${discountAmount ? discountAmount : '0'} ` }}</span>
      </div>
      <van-button v-if="fromOrder" type="primary" block @click="useCoupon">使用</van-button>
    </div>
  </van-action-sheet>
</template>

<script>
import { reactive, toRefs, watch, nextTick } from 'vue'
import { onBeforeRouteLeave } from 'vue-router'
import CouponCard from '@/components/shoppingCart/CouponCard'
import { getBestCoupon } from '@/util/tyreList'

export default {
  props: {
    datas: {
      type: Object,
      default: () => {}
    },
    showPopUp: {
      type: Number,
      default: 0
    },
    fromOrder: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CouponCard
  },
  emits: ['setPreferential', 'click-coupon'],

  setup(props, { emit }) {
    let { datas, showPopUp, fromOrder } = toRefs(props)
    const state = reactive({
      isShow: false,
      datas,
      fromOrder,
      showPopUp,
      // 选中的id
      selectCouponValue: [],
      // 选中的对象数组
      selectCouponArr: [],
      // 优惠总额
      discountAmount: 0,
      couponData: datas.couponListData || [],
      result: [],
      checkboxGroup: [],
      checkboxRefs: [],
      notUseCoupon: false
    })
    onBeforeRouteLeave(() => {
      state.isShow = false
    })
    // 优惠券数据处理
    const getCouponData = (couponListData = []) => {
      return couponListData.map((item, index) => ({
        ...item,
        _flag: `${item.id}_${index}`,
        _type: item.rightId,
        discountAmount: item?.rightContent?.subtractPrice || 0
      }))
    }
    // 多选组件切换
    const toggleSelect = index => {
      // console.log("toggleSelect", index, state.checkboxRefs);
      state.checkboxRefs[index].toggle()
    }
    // 检查选项，并切换
    const checkToggle = (data, index, datas, isReversed) => {
      // data index当前选中的数据和序号，[] 0
      //datas 已经选择的所有数据
      // isReversed 是否需要反选
      nextTick(() => {
        // console.log("checkToggle", data, index);
        // 有不是同一类型的
        if (data && !datas.every(item => item._type === data._type)) {
          if (isReversed) {
            //反转的，将已选不满足条件的选项取消
            state.couponData.map((item, i) => {
              if (state.result.includes(item._flag) && item._flag !== data._flag) {
                nextTick(() => {
                  toggleSelect(i)
                })
              }
            })
          } else {
            // 不反转，保留以前的，取消当前选择的项
            toggleSelect(index)
          }
        }
      })
    }
    // 设置多选结果
    const setResultVal = data => {
      // console.log("setResultVal-->", data);
      if (data?.length) {
        let datas = state.couponData.filter(item => data.includes(item._flag))
        let last = data[data.length - 1]
        let lastArr = last.split('_') //["282", "6"]
        // console.log("state.lastArr-->", lastArr);
        // console.log("state.lastArr-111---->", lastArr[1]);
        let lastObj = state.couponData.filter(item => last === item._flag)
        lastObj = (lastObj && lastObj.length && lastObj[0]) || null
        nextTick(() => {
          checkToggle(lastObj, lastArr[1], datas, true)
          state.selectCouponArr = [...datas]
        })
        state.notUseCoupon = false
      } else {
        state.selectCouponArr = []
        state.notUseCoupon = true
      }
    }
    watch(
      () => state.result,
      data => {
        setResultVal(data)
      },
      { deep: true }
    )
    watch(
      () => state.notUseCoupon,
      n => {
        n && (state.result = [])
      }
    )
    watch(
      () => state.showPopUp,
      () => {
        // state.couponData = getCouponData(state.datas.couponListData);
        nextTick(() => {
          // console.log("showPopUp", state.showPopUp);
          state.isShow = true
        })
      }
    )
    // 设置默认选中
    const setDefaultSelect = (couponData, tyreSelectedList, defaultCoupon) => {
      // console.log("setDefaultSelect--couponSelected--》", couponData,defaultCoupon);
      if (defaultCoupon && defaultCoupon.length) {
        state.result = defaultCoupon
        let datas = state.couponData.filter(item => defaultCoupon.includes(item._flag))
        emit('setPreferential', datas)
        return
      }
      if (defaultCoupon === false) {
        state.result = []
        let datas = []
        state.notUseCoupon = true
        emit('setPreferential', datas)
        return
      }
      // console.log("setDefaultSelect--getBestCoupon--》", couponData, tyreSelectedList);
      let result = getBestCoupon(couponData, tyreSelectedList)
      if (result) {
        let [[, couponSelected] = ['', []]] = Object.entries(result)
        let res = couponSelected.map(({ _flag }) => _flag)
        state.result = res
        emit('setPreferential', couponSelected)
      } else {
        console.error('设置默认选中有误')
        emit('setPreferential', [])
        state.result = []
      }
    }
    watch(
      () => state.datas.couponListData,
      v => {
        // console.log("couponListData-->", v);
        let couponData = getCouponData(v)
        state.couponData = couponData
        const tyreSelectedList = state.datas.tyreSelectedList
        if (v && v.length && tyreSelectedList && tyreSelectedList.length) {
          setDefaultSelect(couponData, tyreSelectedList, state.datas.defaultCoupon)
        } else {
          state.result = []
        }
      }
    )
    watch(
      () => state.selectCouponArr,
      data => {
        // console.log("selectCouponArr-->", data);
        if (data && data.length) {
          nextTick(() => {
            state.selectCouponValue = data.map(({ _flag }) => _flag.split('_')[0])
            state.discountAmount = data.reduce((total, item) => {
              return Math.round(total * 100 + (item?.discountAmount || 0) * 100) / 100
            }, 0)
          })
        } else {
          state.selectCouponValue = []
          state.discountAmount = 0
        }
        nextTick(() => {
          emit('click-coupon', {
            selectCouponArr: data,
            selectCouponValue: state.selectCouponValue,
            discountAmount: state.discountAmount,
            notUseCoupon: state.notUseCoupon
          })
        })
      }
    )
    const useCoupon = () => {
      state.isShow = false
      emit('setPreferential', state.selectCouponArr)
    }
    // 手动设置选中的值
    const setSelected = data => {
      setDefaultSelect(state.couponData, null, data)
    }
    return {
      ...toRefs(state),
      useCoupon,
      setDefaultSelect,
      setSelected
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  padding: 15px 18px 50px;
  color: #333;
}
.rowWrap {
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1;
  text-align: left;
}
.total {
  span {
    font-weight: 600;
  }
  .totalNum {
    color: #c30000;
  }
}
.couponBox {
  margin-top: 12px;
}
.couponCard {
  margin-bottom: 8px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.08);
}
.notSelect {
  height: 40px;
  padding-left: 20px;
  border-radius: 2px;
  border: solid 0.5px #ddd;
  line-height: 40px;
  color: #666666;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  :deep(.van-checkbox) {
    padding-left: 5px !important;
    vertical-align: middle;
  }
}
.explain{
  padding-top: 8px;
  font-size: 12px;
  color: #999;
}
</style>
